import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { useIntegrations } from "../../providers/IntegrationsProvider";
import { TConfig } from "../../services/apiWorker";
import { generatePKCE } from "../../utils/generatePCKE";
import { randomString } from "../../utils/randomString";

export const IntegrationX = {
  type: EIntegrationPlatform.X,
  icon: "/assets/integrations/X.png",
  title: "Twitter",
  description:
    "Allows sharing updates and interacting with pages and events within your app.",

  openAuth: async (config: TConfig) => {
    // const params: { [key: string]: string } = {
    //   client_id: config?.auth.google.clientId || "",
    //   redirect_uri: config?.auth.google.photos.redirectUri || "",
    //   response_type: "code",
    //   scope: config?.auth.google.photos.scopes.join(" ") || "",
    //   include_granted_scopes: "true",
    //   access_type: "offline",
    //   prompt: "consent",
    // };
    // window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
    //   params
    // ).toString()}`;

    const { codeVerifier, codeChallenge } = await generatePKCE();
    const state = randomString();

    localStorage.setItem("twitter_code_verifier", codeVerifier);
    localStorage.setItem("twitter_state", state);

    const params: { [key: string]: string } = {
      response_type: "code",
      client_id: config.auth.twitter.clientId,
      redirect_uri: config.auth.twitter.redirectUri,
      scope: "tweet.read users.read offline.access",
      state,
      code_challenge: codeChallenge,
      code_challenge_method: "S256",
    };

    setTimeout(() => {
      window.location.href = `https://twitter.com/i/oauth2/authorize?${new URLSearchParams(
        params
      ).toString()}`;
    }, 100);
  },

  AuthRender: () => {
    const { addIntegration } = useIntegrations();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
      const scope = searchParams.get("scope");

      const code = searchParams.get("code");
      if (code) {
        console.log(searchParams.toString());
        // Need something to validate, to not remove the scopes from others integrations

        // setSearchParams(new URLSearchParams());

        // const codeVerifier = localStorage.getItem("twitter_code_verifier");

        // if (!codeVerifier) {
        //   message.error("PKCE code not found. Try again.");
        //   return;
        // }

        // getAccessToken({
        //   code,
        //   codeVerifier,
        //   onSuccess: async (data) => {
        //     message.success("Twitter Integration done!");
        //   },
        //   onError: (error) => {
        //     message.error("Error authenticating with Twitter");
        //   },
        // });
      }
    }, [searchParams]);

    return <></>;
  },
};
